import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ListIndex from './OrdersList/ListIndex';
import Statistic from './Reports/Statistic';
import TransactionList from './TransactionList/Index';
import { useEntityCrud } from '../hooks/useEntityCrud';

const Dashboard = () => {

    const navigate = useNavigate();
    const roleId = localStorage.getItem('rl');
    const [businessId,setBusinessId] = useState('')
    const [businessRank,setBusinessRank] = useState(0)

    const { readData } = useEntityCrud(`Business/GetBusiness?BusinessId=${businessId}`)

    useEffect(() => {
        if(roleId == 363){
            navigate('/organizations');
        }else if(roleId == 3){
            setBusinessId(localStorage.getItem('businessId'))
        }
    },[])

    useEffect(() => {
        if(businessId){            
            readData().then(({ data }) => {
                if(data.status){
                    const businessRank = data.result.businessRank || 0;                    
                    if(businessRank > 0)
                        setBusinessRank((businessRank / 20).toFixed(1))
                    else
                        setBusinessRank(0)
                }
            })
        }
    },[businessId])

    return (
        // <OrdersListIndex />
        <>
        <ul className="nav nav-pills mb-3 mt-4" id="pills-tab" role="tablist">
            <li className="nav-item" role="presentation">
                <button className="nav-link active py-3 mb-1 px-5" data-bs-toggle="pill" data-bs-target="#report" type="button" role="tab" aria-controls="orders" aria-selected="true">گزارشات کلی</button>
            </li>
            <li className="nav-item" role="presentation">
                <button className="nav-link py-3 mb-1 px-5" data-bs-toggle="pill" data-bs-target="#orders2" type="button" role="tab" aria-controls="orders" aria-selected="true">سفارشات</button>
            </li>
            <li className="nav-item" role="presentation">
                <button className="nav-link py-3 mb-1 px-5" data-bs-toggle="pill" data-bs-target="#transactions" type="button" role="tab" aria-controls="transactions" aria-selected="false">تراکنش ها</button>
            </li>
        </ul>
        <div className="tab-content" id="pills-tabContent">
            <div className="tab-pane fade show active" id="report" role="tabpanel" aria-labelledby="orders-tab" tabindex="0">
                <Statistic businessRank={businessRank} />
            </div>
            <div className="tab-pane fade" id="orders2" role="tabpanel" aria-labelledby="orders-tab" tabindex="0">
                <ListIndex />
            </div>
            <div className="tab-pane fade" id="transactions" role="tabpanel" aria-labelledby="transactions-tab" tabindex="0">
                <TransactionList isEditMode={true}/>
            </div>
        </div>
        </>
    );
}

export default Dashboard;